// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"7f78ea1e","441":"7f63eabd","542":"d98339f8","661":"f3ca79a8","912":"d8f60785","924":"9429fc77"}[chunkId] + ".css";
};